<template>
  <div>
    <!-- Heating Graphs Desktop -->
    <v-card class="hidden-md-and-down">
      <v-card-title>{{title}}</v-card-title>
      <v-card-subtitle></v-card-subtitle>
      <v-card-text>
        <v-container
          fluid
          class="full-height ma-0 pa-1"
          style="height: 100%; border: 0px solid green"
        >
          <v-row class="fill-height ma-0 pa-0" style="border: 0px solid red">
            <v-col class="ma-0 pa-0" cols="6" style="border: 0px solid red">

                <slot name="monthly_graph"></slot>

            </v-col>

            <v-col class="ma-0 pa-0" cols="6" style="border: 0px solid red">

                <slot name="daily_graph"></slot>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Heating Graphs Mobile -->
    <v-card class="hidden-lg-and-up">
      <v-card-title>{{title}}</v-card-title>
      <v-card-subtitle></v-card-subtitle>
      <v-card-text>
        <v-container
          fluid
          class="full-height ma-0 pa-1"
          style="height: 100%; border: 0px solid green"
        >
          <v-row class="fill-height ma-0 pa-0" style="border: 0px solid red">
            <v-col class="ma-0 pa-0" cols="12" style="border: 0px solid red">

                <slot name="monthly_graph"></slot>

            </v-col>
          </v-row>
          <v-row class="fill-height ma-0 pa-0" style="border: 0px solid red">
            <v-col class="ma-0 pa-0" cols="12" style="border: 0px solid red">

                <slot name="daily_graph"></slot>

            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class PortfolioGraphContainer extends Vue {

    @Prop({default: '', type: String}) public title!: string;

    public mounted() {}
}
</script>
